/**
 * Brand mark — geometric chevron + dot.
 * Modern, distinctive, scales perfectly at any size.
 */
export default function Logomark({ size = 36, className = "" }) {
  return (
    <span
      className={`relative grid place-items-center rounded-xl ${className}`}
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #ffffff, #f3f7ff)",
        border: "1px solid rgba(0,102,255,0.18)",
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.9), 0 6px 16px -6px rgba(0,102,255,0.35)",
      }}
      aria-label="ARJ TEAM logo"
    >
      <svg
        width={size * 0.62}
        height={size * 0.62}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="arj-mark" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%"  stopColor="#0066ff" />
            <stop offset="100%" stopColor="#10b981" />
          </linearGradient>
        </defs>
        <path
          d="M5 25 L16 7 L27 25"
          stroke="url(#arj-mark)"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="16" cy="20" r="2.6" fill="url(#arj-mark)" />
      </svg>
    </span>
  );
}
